<script setup>
import { onMounted, ref } from "vue";
import { findAllUserRequest, savedRequest, updateRequest } from '../api/user';

import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Dialog from 'primevue/dialog';
import Toast from 'primevue/toast';
import Select from 'primevue/select';
import { FilterMatchMode } from '@primevue/core/api';
import { useToast } from "primevue/usetoast";


const activeSpinner = ref(false)
const columns = [
  { field: 'user', header: 'Usuario' },
  { field: 'profile', header: 'Perfil' },
];

const profiles = [
  { codigo : 1 , name: 'Administrador' },
  { codigo : 2 , name: 'Contador' },
  { codigo : 3 , name: 'Emisor' },
]

const toast = useToast();
const dataSource = ref([]);
const modalCreated = ref(false);
const modalUpdate = ref(false);
const title = ref('');

//Source of Saved Data
const id = ref(0)
const username = ref('');
const password = ref('');
const hashPassword = ref('');
const profile = ref('');

const clearData = () => {
  username.value = '';
  password.value = '';
  profile.value = '';
}

const loadData = async () => {
  activeSpinner.value = true;
  try {
    let result = await findAllUserRequest()
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const showModalCreate = async () => {
  clearData();
  modalCreated.value = true;
}

const editProduct = async (data) => {
  modalUpdate.value = true;

  //loadForm
  id.value = data.id
  username.value = data.user
  hashPassword.value = data.pass
  profile.value = data.profile
}

const save = async () => {
  let data = {
    user: username.value,
    password: password.value,
    profile: profile.value,
  }

  let res = await savedRequest(data);
  if (res.status == 201 && res.data.message == 'saved successfully user') {
    modalCreated.value = false;
    toast.add({ severity: 'success', summary: 'Usuario', detail: 'Creado Correctamente', life: 4000 });
    loadData();
    clearData();
  }
}

const update = async() => {
  let data = {
    id: id.value,
    user: username.value,
    password: password.value,
    hash_password : hashPassword.value,
    profile: profile.value,
  }
  let res = await updateRequest(data);
  if(res.status == 201 && res.data.message == 'update successfully user'){
    modalUpdate.value = false;
    toast.add({ severity: 'info', summary: 'Usuario', detail: 'Actualizado Correctamente', life: 4000 });
    loadData();
    clearData();
  }
}

onMounted(() => {
  loadData();
});
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Configuracion Facturador</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2 mt-4">
      <Toolbar class="mb-6 m-3">
        <template #start>
          <Button label="Crear" icon="pi pi-plus" severity="success" class="m-2" @click="showModalCreate" />
          <Button label="Recargar" icon="pi pi-replay" severity="info" class="m-2" @click="loadData" />
          <Toast />
        </template>
        <template #end>
          <IconField>
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
          </IconField>
        </template>
      </Toolbar>

      <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
      </div>

      <DataTable v-if="!activeSpinner" class="m-3 text-center" :value="dataSource" :paginator="true" :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]" :filters="filters" stripedRows resizableColumns columnResizeMode="fit"
        showGridlines tableStyle="min-width: 50rem">
        <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
        <Column :exportable="false" style="min-width: 1rem">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" outlined rounded class="mr-2" severity="info"
              @click="editProduct(slotProps.data)" />
          </template>
        </Column>
      </DataTable>

      <!-- //---Modal Create---// -->
      <Dialog v-model:visible="modalCreated" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
            <span class="font-bold whitespace-nowrap">Guardar Facturador</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Nombre De Usuario</label>
                <input type="text" v-model="username" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Contraseña</label>
                <input type="text" v-model="password" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Perfil</label>
                <Select v-model="profile" :options="profiles" optionValue="codigo" filter optionLabel="name" class="form-select form-select-sm" />
              </div>
            </div>
          </div>
        </div>
        <!-- //---Form---// -->
        <template #footer>
          <Button label="Cancel" text severity="danger" @click="modalCreated = false" autofocus />
          <Button label="Guardar" outlined severity="primary" @click="save" autofocus />
        </template>
      </Dialog>

      <!-- //---Modal Update---// -->
      <Dialog v-model:visible="modalUpdate" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
            <span class="font-bold whitespace-nowrap">Actualizar Facturador</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Nombre De Usuario</label>
                <input type="text" v-model="username" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Contraseña</label>
                <input type="text" v-model="password" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label">Perfil</label>
                <Select v-model="profile" :options="profiles" optionValue="codigo" filter optionLabel="name" class="form-select form-select-sm" />
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Cancel" text severity="danger" @click="modalUpdate = false" autofocus />
          <Button label="Actualizar" outlined severity="primary" @click="update" autofocus />
        </template>
      </Dialog>
    </div>
  </div>
</template>

<style scoped>
.inputCreate {
  height: 3rem !important;
}
</style>
